
import { Component, Vue } from 'vue-property-decorator'
import { ElForm } from 'element-ui/types/form'
import { PlanReportAdd, MonthPlanList } from '@/types/operationMonthReport.d'

@Component
export default class extends Vue {
  private formData: PlanReportAdd = {
    planType: '3',
    projectId: '',
    planStart: '',
    planEnd: '',
    status: '',
    yhWeekPlanList: [],
    yhMonthPlanList: []
  }

  private rangeDate: Array<string> = []
  private submitShow = false
  private loading = false
  private isEdit: number | null = null
  private oldData = ''
  private rules = {
    projectId: [
      { required: true, message: '请选择所属项目', trigger: 'change' }
    ],
    planStart: [
      { required: true, message: '请选择计划周期', trigger: 'change' }
    ],
    yhMonthPlanList: [
      { required: true, message: '请添加月工作明细', trigger: 'change' }
    ]
  }

  private tableRules = {
    position: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    plant: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    content: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    person: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    weekOne: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    weekTwo: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    weekThree: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    weekFour: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    weekFive: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    complete: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ],
    verifier: [
      { required: true, message: '该字段不可为空', trigger: 'change' }
    ]
  }

  get normalProjectList () {
    return this.$store.state.normalProjectList
  }

  get reportId () {
    return this.$route.params.reportId || ''
  }

  created () {
    this.reportId && this.getDetail()
  }

  getDetail () {
    this.loading = true
    this.$axios.get(this.$apis.operationmanage.selectYhPlanReportByReportId, { reportId: this.reportId }).then((res) => {
      this.formData = res
      this.rangeDate = [this.formData.planStart, this.formData.planEnd]
      this.formData.yhMonthPlanList.forEach((item) => {
        item.isInput = false
      })
      this.formData.yhMonthPlanList = JSON.parse(JSON.stringify(this.formData.yhMonthPlanList))
    }).finally(() => {
      this.loading = false
    })
  }

  // 展示时间
  changetimers (val: string[]) {
    if (val && val[0] && val[1]) {
      this.formData.planStart = val[0]
      this.formData.planEnd = val[1]
    } else {
      this.formData.planStart = ''
      this.formData.planEnd = ''
    }
  }

  // 列表添加
  onAdd () {
    if (this.isEdit !== null) {
      this.$message.warning('请先保存！')
    } else {
      this.formData.yhMonthPlanList.push({
        position: '',
        plant: '',
        content: '',
        person: '',
        weekOne: '',
        weekTwo: '',
        weekThree: '',
        weekFour: '',
        weekFive: '',
        complete: '',
        verifier: '',
        isInput: true
      })
      this.$nextTick(() => {
        // 滚动到表格最底部
        ;(this.$refs.editTable as any).bodyWrapper.scrollTop = (this.$refs.editTable as any).bodyWrapper.scrollHeight
      })
      this.isEdit = this.formData.yhMonthPlanList.length - 1
    }
  }

  // 保存当条
  onSave (row: MonthPlanList, index: number) {
    ;(this.$refs.addTable as ElForm).validate((valid) => {
      if (valid) {
        row.isInput = false
        this.$set(this.formData.yhMonthPlanList, index, this.formData.yhMonthPlanList[index]) // 重新渲染表格数据
        this.isEdit = null
      }
    })
  }

  // 列表编辑当条
  onEdit (row: MonthPlanList, index: number) {
    if (this.isEdit !== null) {
      this.$message.warning('请先保存！')
    } else {
      this.oldData = JSON.stringify(row)
      row.isInput = true
      this.isEdit = index
      this.$set(this.formData.yhMonthPlanList, index, this.formData.yhMonthPlanList[index]) // 重新渲染表格数据
    }
  }

  // 当条取消编辑
  onCancel (row: MonthPlanList, index: number) {
    this.isEdit = null
    if (this.oldData[index]) {
      // 是否为编辑
      this.formData.yhMonthPlanList[index] = JSON.parse(this.oldData)
      this.formData.yhMonthPlanList[index].isInput = false // 取消值不变
      this.$set(this.formData.yhMonthPlanList, index, this.formData.yhMonthPlanList[index]) // 重新渲染表格数据
    } else {
      this.formData.yhMonthPlanList.splice(index, 1)
    }
  }

  // 删除当条
  onDelete (index: number) {
    if (this.isEdit !== null) {
      this.$message.warning('请先保存！')
    } else {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.formData.yhMonthPlanList.splice(index, 1)
        this.$message.success('删除成功')
      })
    }
  }

  onSubmit (num: string) {
    (this.$refs.formData as ElForm).validate(valid => {
      if (valid) {
        if (this.isEdit !== null) {
          this.$message.warning('请先保存！')
        } else {
          this.formData.yhMonthPlanList.forEach(item => {
            delete item.isInput
          })
          this.formData.status = num
          this.submitShow = true
          const url = this.reportId
            ? this.$apis.operationmanage.updateYhPlanReport
            : this.$apis.operationmanage.insertYhPlanReport
          this.$axios.post(url, {
            ...this.formData
          }).then(() => {
            this.$message.success('添加成功')
            this.closeAdd()
          }).catch(() => {
            this.formData.yhMonthPlanList.forEach(item => {
              item.isInput = false
            })
          }).finally(() => {
            this.submitShow = false
          })
        }
      }
    })
  }

  // 关闭
  closeAdd () {
    this.$router.back()
  }
}
